<template>
    <div
        id="modal-message-delete"
        aria-hidden="true"
        aria-labelledby="modalFillInLabel"
        class="modal animation opacity modal-default modal-delete"
        role="dialog"
        tabindex="-1"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button aria-hidden="true" class="close" data-dismiss="modal" type="button">
                        <svg
                            height="16"
                            viewBox="0 0 10 10"
                            width="16"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                            <defs>
                                <path id="qczca" d="M1110 328l8-8" />
                                <path id="qczcb" d="M1110 320l8 8" />
                            </defs>
                            <g>
                                <g transform="translate(-1109 -319)">
                                    <g>
                                        <use
                                            fill="#fff"
                                            fill-opacity="0"
                                            stroke="#5937B7"
                                            stroke-linecap="square"
                                            stroke-miterlimit="50"
                                            stroke-width="1.5"
                                            xlink:href="#qczca"
                                        />
                                    </g>
                                    <g>
                                        <use
                                            fill="#fff"
                                            fill-opacity="0"
                                            stroke="#5937B7"
                                            stroke-linecap="square"
                                            stroke-miterlimit="50"
                                            stroke-width="1.5"
                                            xlink:href="#qczcb"
                                        />
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </button>

                    <strong>{{ __('Delete message') }}</strong>
                    <p v-html="__(`Do you really want to delete your message? This step cannot be undone.`)"></p>
                </div>

                <div class="modal-body">
                    <div class="btn-group">
                        <VButton :label="__('Keep')" @onClick="close" />
                        <VButton :label="__('Delete message')" color="danger" @onClick="remove" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    props: {
        message: {
            type: Object,
            required: false
        },
        conversation: {
            type: Object,
            required: true
        }
    },
    methods: {
        ...mapActions({
            deleteMessage: 'chat/deleteMessage'
        }),
        remove() {
            const message = this.message
            const channel_id = this.conversation.channel_id

            this.deleteMessage({message, channel_id})

            $('#modal-message-delete').modal('hide')
        },
        close() {
            $('#modal-message-delete').modal('hide')
        }
    }
}
</script>
